import React from 'react';
import PropTypes from 'prop-types';
import { get as getProperty } from 'lodash';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { get } from 'helpers/api';

import TaskForm from 'components/tasks/task_form';
import { addTask } from './store/actions/leads';
import { hideTaskModal } from './store/actions/ui';

export class TaskModal extends React.Component {
  static propTypes = {
    addTask: PropTypes.func.isRequired,
    availableDatabaseOptions: PropTypes.arrayOf(PropTypes.array),
    defaultTaskAssignee: PropTypes.object.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    hideByProjectSelect: PropTypes.bool,
    hideContactSelect: PropTypes.bool,
    hideProjectSelect: PropTypes.bool,
    hidePropertySelect: PropTypes.bool,
    hideTaskModal: PropTypes.func.isRequired,
    isLogged: PropTypes.bool,
    lead: PropTypes.object,
    multipleProjects: PropTypes.bool,
    show: PropTypes.bool
  }

  defaultTaskAssociations() {
    const { lead } = this.props;

    if (!lead) return null;

    const projectAssociation = {
      associatedModelId: lead.projectId,
      associatedModelType: 'Project',
      name: lead.projectName,
      default: true
    };
    const contactAssociation = {
      associatedModelId: lead.contactId,
      associatedModelType: lead.contactType,
      name: lead.leadData.name,
      default: true
    };

    return [projectAssociation, contactAssociation];
  }

  state = {
    assigneeOptionsProjectId: null,
    assigneeOptions: []
  }

  componentDidUpdate() {
    this.pullAssigneeOptions();
  }

  pullAssigneeOptions() {
    if (!this.props.show) return;

    const newProjectId = getProperty(this.props, 'lead.projectId');
    if (this.state.assigneeOptionsProjectId === newProjectId) return;

    const usersPath = getProperty(this.props, 'lead.projectUsersPath');
    if (!usersPath) return;

    get(usersPath).then((response) => {
      const assigneeOptions = [...response];

      if (response.every(user => user.id !== this.props.defaultTaskAssignee.id)) {
        assigneeOptions.unshift(this.props.defaultTaskAssignee);
      }
      this.setState({ assigneeOptionsProjectId: newProjectId, assigneeOptions });
    });
  }

  render() {
    const selectedContactName = this.props.lead ? this.props.lead.displayName : null;

    return (
      <Modal
        backdrop="static"
        className="contact-modal fill-required overflow-visible"
        name="task-form-modal"
        show={this.props.show}
        onHide={this.props.hideTaskModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.isLogged ? 'Log an Activity' : 'Create a Task'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TaskForm
            assigneeOptions={this.state.assigneeOptions}
            availableDatabaseOptions={this.props.availableDatabaseOptions}
            defaultAssociatedModels={this.defaultTaskAssociations()}
            defaultTaskAssignee={this.props.defaultTaskAssignee}
            errors={this.props.errors}
            hideByProjectSelect={this.props.hideByProjectSelect}
            hideContactSelect={this.props.hideContactSelect}
            hideProjectSelect={this.props.hideProjectSelect}
            hidePropertySelect={this.props.hidePropertySelect}
            logTask={this.props.isLogged}
            projectId={this.props.lead ? this.props.lead.projectId : null}
            providedTitle={selectedContactName ? `Call with ${selectedContactName}` : null}
            selectedContactName={selectedContactName}
            onCancel={this.props.hideTaskModal}
            onSave={this.props.addTask}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = ({ availableDatabaseOptions, currentUser, defaultTaskAssignee, ui }) => {
  return {
    availableDatabaseOptions,
    defaultTaskAssignee,
    errors: ui.taskModalErrors,
    hideByProjectSelect: !currentUser.marketingListingsAccess,
    hideContactSelect: !currentUser.taskAssociationsEnabled,
    hideProjectSelect: !currentUser.marketingListingsAccess,
    hidePropertySelect: !currentUser.taskAssociationsEnabled,
    hideByProject: !currentUser.marketingListingsAccess,
    isLogged: ui.isLogged,
    lead: ui.lead,
    show: ui.showTaskModal
  };
};

const actions = { addTask, hideTaskModal };

export default connect(mapStateToProps, actions)(TaskModal);
